import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

import Datastore from "../../communication/Datastore";

import Permission from "../../types/system/Permission";

import store from "../Store";

// Define the type for our state store entry
type PermissionsState = {
    permissions: Permission[];
    restricted: Permission[];
    status: string;
    error: string;
};

// Define the initial state for our state store entry
const initialState: PermissionsState = {
    permissions: [],
    restricted: [],
    status: "idle",
    error: null,
};

// Create a slice to hold all our reducers
const pemissionsSlice = createSlice({
    name: "permissions",
    initialState: initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(REHYDRATE, (_, rawData: any) => {
                if (rawData?.key !== "tts") return undefined;
                return {
                    permissions:
                        rawData?.payload?.permissions?.permissions ?? [],
                    restricted: rawData?.payload?.permissions?.restricted ?? [],
                    status: "idle",
                    error: null,
                };
            })
            .addCase(fetchPermissions.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(fetchPermissions.fulfilled, (state, action) => {
                state.permissions = action.payload[0];
                state.restricted = action.payload[1];
                state.status = "succeeded";
            })
            .addCase(fetchPermissions.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

// This is a thunk, they are used to load the state
const fetchPermissions = createAsyncThunk(
    "permissions/fetchPermissions",
    async () => {
        return await Promise.all([
            Datastore.getType<Permission[]>("api/Permissions"),
            Datastore.getType<Permission[]>("api/Permissions/Restricted"),
        ]);
    },
);
export const initialisePermissions = createAsyncThunk(
    "permissions/initialisePermissions",
    async (_, thunkAPI) => {
        const { permissions } = store.getState().db;

        if (permissions.status !== "idle") return;

        await thunkAPI.dispatch(fetchPermissions());
    },
);

// We have to export the reducer as this is added to the state store
export default pemissionsSlice.reducer;
